<template>
  <div>
    <form @submit.prevent="submitCategory">
      <v-row>
        <v-col
          cols="12"
          md="8"
          sm="4"
        >
          <v-card outlined>
            <v-card-text>
              <div>General</div>
              <v-row>
                <v-col
                  cols="12"
                  md="8"
                >
                  <v-text-field
                    v-model="category.name"
                    hide-details="auto"
                    label="Category Name"
                    outlined
                    dense
                    :error-messages="errors.getMessage('name')"
                  />
                </v-col>

                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
                    v-model="category.barcode"
                    hide-details="auto"
                    label="Category code"
                    outlined
                    dense
                    :error-messages="errors.getMessage('barcode')"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card
            v-if="category.mode"
            class="mt-5"
            outlined
          >
            <v-card-text>
              <div>Relationship</div>
              <v-row>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-autocomplete
                    v-model="category.parent_id"
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    outlined
                    label="Parent Category (Child of)"
                    chips
                    :item-disabled="checkIsItemSelf"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="12"
                >
                  <v-autocomplete
                    v-model="category.children"
                    :items="categories"
                    item-text="name"
                    item-value="id"
                    outlined
                    multiple
                    label="Childen categories (Parent of)"
                    chips
                    :item-disabled="checkIsItemParent"
                  />
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col
          cols="12"
          md="4"
          sm="12"
        >
          <v-card
            outlined
            class="mt-4"
          >
            <v-card-text v-if="categories">
              <div>Properties</div>
              <v-checkbox
                v-model="category.mode"
                label="Relationship mode"
              />
            </v-card-text>
          </v-card>
          <div class="text-center">
            <v-btn
              color="green"
              class="ma-2 white--text"
              type="submit"
            >
              Save
              <v-icon
                right
                dark
              >
                mdi-plus
              </v-icon>
            </v-btn>
            <v-btn
              class="ma-2"
              :to="{ name: 'ProductsCategories' }"
            >
              Cancel
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      edit: false,
      category: {
        mode: false,
        children: [],
      },
      categories: [],
    };
  },
  computed: {
    ...mapGetters({
      errors: "validation/pull",
    }),
  },
  mounted() {
    this.getFromApi();
    if (this.$route.params.id) {
      window.axios
        .get("/category/" + this.$route.params.id)
        .then((response) => {
          this.$data.category = response.data.category;
          this.$data.edit = true;
        });
    }
  },
  methods: {
    ...mapActions({
      feedback: "snackbar/show",
    }),
    checkIsItemSelf(item) {
      return item.id === this.$data.category.id;
    },
    checkIsItemParent(item) {
      let checkOne = this.$data.category.id;
      let checkTwo = this.$data.category.parent_id;
      return item.id === checkOne || item.id === checkTwo;
    },
    redirect(info) {
      this.feedback(info.data.message);
      this.$router.replace({ name: "ProductsCategories" });
    },
    updateCategory() {
      let data = this.$data.category;
      window.axios.patch("/category/" + data.id, data).then((response) => {
        this.redirect(response);
      });
    },
    createCategory() {
      window.axios.post("/category", this.$data.category).then((response) => {
        this.redirect(response);
      });
    },
    submitCategory() {
      if (this.$data.edit) {
        this.updateCategory();
      } else {
        this.createCategory();
      }
    },
    getFromApi() {
      window.axios.get("/product-form-data").then((response) => {
        this.categories = response.data.categories;
      });
    },
  },
};
</script>
